



















































import Vue from "vue";
import data from "@/data/userData";
import Dan from "@/models/Dan";
import User from "@/models/User";

export default Vue.extend({
  created() {
    Dan.insert({ data: data });
  },

  computed: {
    dans(): Dan[] {
      const danArray: Dan[] =
        Dan.query()
          .where((dan: Dan) => {
            return dan.data?.length > 0 && dan.hierarchy?.includes("national");
          })
          // .orderBy("dan", "desc")// not working with correct sort order for integers
          .get() || [];
      danArray
        ?.sort((a: any, b: any) => {
          return b.dan - a.dan;
        }) // added manual sorting after commenting orderBy in the query
        .forEach((dan: Dan) => {
          const validUsers: User[] =
            dan.data?.filter((user: User) => {
              user.danclass = dan.danclass;
              return user?.danposition;
            }) || [];
          dan.data =
            validUsers?.sort((a, b) => {
              return a.danposition - b.danposition;
            }) || [];
        });
      return danArray;
    },
  },

  methods: {
    resetScrollToContainerTop(): void {
      const container: HTMLElement | null =
        document?.querySelector(".container");
      if (container) {
        container.scrollTop = 0;
      }
    },

    getImgUrl(pic: string): any {
      return require(`../assets/images/${pic}`);
    },
  },

  mounted() {
    this.resetScrollToContainerTop();
  },
});
